<div container [isFluid]="true" [noGutters]="true">
  <div class="what-is-screen__decorator" decorator [lineLeft]="decorator"></div>
  <div class="what-is-screen d-flex flex-column flex-lg-row">
    <div class="what-is-screen__text text-white">
      <h2>What is type 1 diabetes&nbsp;screening?</h2>
      <p class="mb-lg-3">
        Screening identifies the risk of developing type 1 diabetes (T1D). When the body starts mistakenly attacking its
        own insulin-producing beta cells, certain markers called T1D autoantibodies (AAbs) can be found in the blood.
        Unlike a blood sugar level test, AAb screening looks for these T1D-related autoantibodies and can detect T1D
        before symptoms begin.
      </p>
      <p class="mb-0">
        <span class="fw-bold"> Screening is often low or even no cost depending on insurance. </span> Early T1D
        screening can give people critical
        information to take action and proactively seek out monitoring and management options.
      </p>
    </div>
    <div class="what-is-screen__image position-relative flex-grow-1">
      <picture [data]=" {
        image: 'how-to-screen/what-is-screen',
        altext: 'Two young women lounging and looking at a notebook',
        format: '',
        width: '710',
        height: '528',
        mobile: true,
        webp: true,
        fill: true,
        classes: 'img-fluid object-fit-cover',
      }"></picture>
      <div class="what-is-screen__image-caption position-absolute bottom-0 start-0">
        Actor portrayal
      </div>
    </div>
  </div>
</div>